module.exports = __webpack_public_path__ + "static/media/bg-rear.612ef30a.png";